export const M365_OAUTH_CALLBACK_MESSAGE = "theo:m365-oauth-callback";
export const TEAMS_OAUTH_CALLBACK_MESSAGE = "theo:teams-oauth-callback";
export const M365_OAUTH_CALLBACK_PATH = "/m365/oauth/callback";
export const TEAMS_OAUTH_STATE_PREFIX = "teams-catalog.";

export interface M365OAuthCallbackMessage {
  type: typeof M365_OAUTH_CALLBACK_MESSAGE | typeof TEAMS_OAUTH_CALLBACK_MESSAGE;
  code?: string;
  state?: string;
  error?: string;
  errorDescription?: string;
}

export function getM365DelegatedRedirectUri(): string {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${M365_OAUTH_CALLBACK_PATH}`;
  }
  return M365_OAUTH_CALLBACK_PATH;
}

export function createM365OAuthState(): string {
  const bytes = new Uint8Array(16);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  }
  return `${Date.now().toString(16)}${Math.random().toString(16).slice(2)}`;
}

export function asM365OAuthCallbackMessage(data: unknown): M365OAuthCallbackMessage | null {
  if (!data || typeof data !== "object") return null;
  const message = data as Record<string, unknown>;
  if (message.type !== M365_OAUTH_CALLBACK_MESSAGE && message.type !== TEAMS_OAUTH_CALLBACK_MESSAGE) return null;
  return {
    type: message.type as M365OAuthCallbackMessage["type"],
    code: typeof message.code === "string" ? message.code : undefined,
    state: typeof message.state === "string" ? message.state : undefined,
    error: typeof message.error === "string" ? message.error : undefined,
    errorDescription: typeof message.errorDescription === "string" ? message.errorDescription : undefined,
  };
}
